import React from "react";

import { Collapse } from "@material-ui/core";
import { Alert as MaterialUiAlert, AlertTitle } from "@material-ui/lab";

import { AlertProps } from "./types";
import useStyles from "./styles";

const Alert = ({ visible, severity, title, message, action }: AlertProps) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Collapse in={visible}>
        <MaterialUiAlert severity={severity} action={action}>
          {title && <AlertTitle>{title}</AlertTitle>}

          <div>{message}</div>
        </MaterialUiAlert>
      </Collapse>
    </div>
  );
};

export default Alert;
